import React from 'react';
import Image from './Image';
import Product from '../parts/Product';

export default props => {
  return (
    <div className="module module--stage">
      <div className="stage">
        <div className="left" style={{backgroundColor: props.background}}>
          <div className="inner">
            <Product handle={props.product_handle} type="teaser" visible={true} />
          </div>
        </div>
        <div className="right">
          <Image
            image={props.image}
            preline={props.preline}
            headline={props.headline}
            subline={props.subline}
            credits={props.credits}
            />
        </div>
      </div>
    </div>
  )
}
